// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","396":"fba93ad7","455":"d639c004","977":"00323907"}[chunkId] + ".chunk.js";
};